export function getWeekNumber(week: Date[]): number {
  const midWeek = (week[0].getTime() + week[1].getTime()) / 2;

  return new Date(midWeek).getWeek();
}
